import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Button } from 'reactstrap';
import { ROUTE_LOGIN_EMAIL, ROUTE_SIGNUP } from '../../constants/routes';
import { FaUserAlt } from 'react-icons/fa';
import { useState, useEffect } from 'react';

const Login = () => {
	return (
		<div className="login" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/login/Bg-Login.jpg)` }}>
			<img src={process.env.PUBLIC_URL + '/images/gbm-logo.png'} alt="GBM Logo" className="gbm-logo" />
			<div className="login-options">
				<div className="login-title">{'Ingresa con tu cuenta de:'}</div>
				{/* <Row className="login-option">
                    <Button
                        color=""
                        className="login-option-button"
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/images/login/facebook_logo.svg'}
                            alt="Facebook Logo"
                            className="login-icon"
                        />
                        <span className="button-label">
                            {"Facebook"}
                        </span>
                    </Button>
                </Row>
                <Row className="login-option">
                    <Button
                        color=""
                        className="login-option-button"
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/images/login/twitter_logo.svg'}
                            alt="Twitter Logo"
                            className="login-icon"
                        />
                        <span className="button-label">
                            {"Twitter"}
                        </span>
                    </Button>
                </Row> */}
				<Row className="login-option">
					<Button color="" className="login-option-button" tag={Link} to={ROUTE_LOGIN_EMAIL}>
						<FaUserAlt size={'10%'} style={{ color: '#086326' }} />
						<span className="button-label">{'Usuario'}</span>
					</Button>
				</Row>
			</div>
			<Row className="login-footer">
				<span>{'¿No tienes una cuenta? '}</span>
				&nbsp;
				<Link to={ROUTE_SIGNUP}>{'Regístrate ahora'}</Link>
			</Row>
		</div>
	);
};

export default Login;
